import Login from '../components/Auth/LoginEmail'

let routes = {
    path: '/login-email',
    component: Login
}

export default routes



// WEBPACK FOOTER //
// ./src/router/loginEmail.js